export default "__VITE_PUBLIC_ASSET__d9d18aaa__"